<script>
/**
 * ResponsiveTable
 * ---------------------------------------------------------------------------
 * Envuelve cualquier tabla (vuetable-2, <b-table> o <table> crudo) para
 * garantizar scroll horizontal seguro en móvil/tablet (estrategia elegida:
 * "scroll horizontal", mínimo riesgo, conserva todas las columnas).
 *
 * NO altera datos ni columnas: es puramente presentacional. El contenido de
 * la tabla se pasa por el slot por defecto, intacto.
 *
 * Props:
 *   minWidth  -> ancho mínimo de la tabla antes de activar scroll (px o css).
 *                Evita que las columnas se aplasten. Default: 'auto'.
 *   bordered  -> añade un borde sutil al contenedor scrollable.
 *
 * Uso:
 *   <ResponsiveTable :min-width="720">
 *     <vuetable ... />            // o <table>...</table>  o  <b-table .../>
 *   </ResponsiveTable>
 */
export default {
  name: "ResponsiveTable",
  props: {
    minWidth: {
      type: [String, Number],
      default: "auto",
    },
    bordered: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerStyle() {
      if (this.minWidth === "auto" || this.minWidth === null) return {};
      const value = typeof this.minWidth === "number" ? `${this.minWidth}px` : this.minWidth;
      return { minWidth: value };
    },
  },
};
</script>

<template>
  <div
    class="table-responsive rwd-table"
    :class="{ 'rwd-table--bordered': bordered }"
  >
    <div class="rwd-table__inner" :style="innerStyle">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.rwd-table {
  -webkit-overflow-scrolling: touch;
}
.rwd-table--bordered {
  border: 1px solid var(--bs-border-color, #eff2f7);
  border-radius: 0.25rem;
}
/* Garantiza que la tabla interna pueda forzar el scroll cuando se define
   un min-width, sin tocar el marcado de la tabla. */
.rwd-table__inner {
  width: 100%;
}
.rwd-table__inner >>> table {
  margin-bottom: 0;
}
</style>
